/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { uid } from 'react-uid';

const skuBuilderWithDash = (sku) => {
    const endIndex = sku.lastIndexOf('-') + 1;
    return sku.slice(endIndex);
};

const skuBuilderWithUnderscore = (sku) => {
    const firstUnderscoreIndex = sku.indexOf('_');
    return sku.slice(firstUnderscoreIndex + 1, sku.length);
};

export const skuBuilder = (sku) => (sku.indexOf('-') !== -1 ? skuBuilderWithDash(sku) : skuBuilderWithUnderscore(sku));

export const formatGiftMessage = (data, styleClass) => {
    let message = '';
    if (data) {
        message = data.split('|').map((line, index) => (<p key={uid('giftMessage_', index)} className={styleClass}>{line}</p>));
    }
    return message || 'No Card Message';
};

export const getNormalizeGiftMessageGCI = (orderItem) => {
    const greetingCards = orderItem.greetingCards || [];
    let giftMessageGciData = {};

    if (greetingCards?.length > 0) {
        const gciData = greetingCards[0] || {};
        const xOrderAttrValues = (gciData?.xOrderAttrValues || gciData?.xorderAttrValues || {});
        giftMessageGciData = {
            data: {
                thumbnail: (xOrderAttrValues.GCIThumbnail || xOrderAttrValues.CIImage || ''),
                text: ((orderItem.field2 !== '') ? orderItem.field2?.replace('GCI=', '') : ''),
                price: `$${(xOrderAttrValues.gciItemPrice || xOrderAttrValues.CIItemPrice || '')}`,
                gciItemId: (gciData.greetingCardItemId || ''),
                gciKeyId: (xOrderAttrValues.GCIkey_Id || xOrderAttrValues.CIkey_Id || ''),
            },
        };
    }
    return giftMessageGciData;
};

export const getIfDateIsPastDate = (date) => {
    const objDate = new Date(date);
    const now = new Date().setHours(0, 0, 0, 0);
    if (objDate < now) {
        return true;
    }
    return false;
};

export const checkDateIsDeliverable = (deliveryDate) => {
    if (deliveryDate) {
        const isPastDate = getIfDateIsPastDate(deliveryDate);
        if (isPastDate) {
            return 'No';
        }
        return 'Yes';
    }
    return 'NoDate';
};

// Use for currency format for ex:
// 1000 => 1,000
// 80000 => 80,000
// 1000000 => 1,000,000
export const setCurrencyFormatforTotalOrder = (totalPrice) => {
    if (totalPrice) {
        return totalPrice.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
    return null;
};

export default {};
